import { render, staticRenderFns } from "./FeatureWelcome.vue?vue&type=template&id=65ba74b7&scoped=true&"
import script from "./FeatureWelcome.vue?vue&type=script&lang=js&"
export * from "./FeatureWelcome.vue?vue&type=script&lang=js&"
import style0 from "./FeatureWelcome.vue?vue&type=style&index=0&id=65ba74b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ba74b7",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/FeatureWelcome.vue
// module id = 250
// module chunks = 0